"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.useCanvasQueries = (canvasQueries) => {
    return react_1.useMemo(() => {
        const returnVal = {
            failedQueries: Object.values(canvasQueries).filter(q => {
                return !!(q && q.result && q.result.error);
            }),
            loadingQueries: Object.values(canvasQueries).filter(q => {
                return !!(q && q.result && q.result.loading);
            }),
        };
        return Object.assign(Object.assign({}, returnVal), { errors: returnVal.failedQueries.map(q => q && q.result.error), hasFailed: returnVal.failedQueries.length > 0, isLoading: returnVal.loadingQueries.length > 0 });
    }, [canvasQueries]);
};
//# sourceMappingURL=useCanvasQueries.js.map